import { render } from "./GameResultTable.vue?vue&type=template&id=6849ea98&scoped=true"
import script from "./GameResultTable.vue?vue&type=script&lang=js"
export * from "./GameResultTable.vue?vue&type=script&lang=js"

import "./GameResultTable.vue?vue&type=style&index=0&id=6849ea98&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6849ea98"]])

export default __exports__